import React, {
  Component,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import {
  Button,
  Row,
  Modal,
  Form,
  Container,
  Col,
  InputGroup,
  ButtonGroup,
  ToggleButton,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import {
  StorefrontShippingOption,
  GiftCardShippingAddress,
  StorefrontApi,
  StorefrontSettingsViewModel,
} from "../../apiclient";
import { apiConfig } from "../../config";
import toast, { LoaderIcon, Toaster } from "react-hot-toast";
import "./PublicStorefront.css";
import { LoadScript, Autocomplete } from "@react-google-maps/api";
import countries from 'i18n-iso-countries';
// Import language data for localization (e.g., English)
import en from 'i18n-iso-countries/langs/en.json';
import CurrencyUtil from "../../Helpers/CurrencyUtil";
//import "./assets.css";

interface PublicStorefrontShippingDetailsComponentProps {
  settings: StorefrontSettingsViewModel;
  shippingAddress: GiftCardShippingAddress;
  shippingOption: StorefrontShippingOption;
  updated: any;
}
const libraries: ("places")[] = ["places"]; // Load Places library from Google Maps API

const PublicStorefrontShippingDetailsComponent = (
  props: PublicStorefrontShippingDetailsComponentProps
) => {
  const [model, setModel] = useState({} as GiftCardShippingAddress);
  const [settings, setSettings] = useState({} as StorefrontSettingsViewModel);
  const [modelShipping, setModelShipping] = useState({} as StorefrontShippingOption);
  const [validated, setValidated] = useState(false);
  const [autocomplete, setAutocomplete] = useState<google.maps.places.Autocomplete | null>(null);

  countries.registerLocale(en);
  const countryList = countries.getNames('en');
  const countryOptions = Object.entries(countryList).map(([code, name]) => ({
    code,
    name,
  }));

  const handleLoad = (autocompleteInstance: google.maps.places.Autocomplete): void => {
    setAutocomplete(autocompleteInstance);
  };

  const handlePlaceChanged = (): void => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      const components: { [key: string]: string } = {
        street_number: "",
        route: "",
        locality: "",
        administrative_area_level_1: "",
        postal_code: "",
        country: "",
        country_code: ""
      };

      if (place.address_components) {
        place.address_components.forEach((component) => {
          component.types.forEach((type) => {
            if (components.hasOwnProperty(type)) {
              components[type] = component.long_name;
              if (type === "country") {
                components["country_code"] = component.short_name;
              }
            }
          });
        });

        setModel({
          name: model.name,
          address1: `${components.street_number} ${components.route}`.split(",")[0],
          address2: model.address2,
          city: components.locality,
          state: components.administrative_area_level_1,
          postalCode: components.postal_code,
          country: components.country,
          countryCode: components.country_code
        });
      }
    }
  };

  const handleChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = event.target.name;
    setModel((values: GiftCardShippingAddress) => ({
      ...values,
      [name]: value,
    }));
  };

  const handleCountryChange = (e: any) => {
    const selectedCode = e.target.value;
    setModel((values: GiftCardShippingAddress) => ({
      ...values,
      countryCode: selectedCode,
      country: countries.getName(selectedCode, 'en')
    }));
  };

  const handleShippingChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = event.target.name;

    var selectedShipping = props.settings.shippingOptions?.find(item => item.id === value);
    if (selectedShipping) {
      setModelShipping(selectedShipping!);
    }
  };

  useEffect(() => {
    setValidated(false);
    if (props.shippingAddress) {
      setModel({
        address1: props.shippingAddress.address1,
        address2: props.shippingAddress.address2,
        city: props.shippingAddress.city,
        country: props.shippingAddress.country,
        countryCode: props.shippingAddress.countryCode,
        postalCode: props.shippingAddress.postalCode,
        name: props.shippingAddress.name,
        state: props.shippingAddress.state
      });
    }

    if (props.settings) {
      setSettings(props.settings);
    }

    if (props.settings && props.settings.shippingOptions) {
      setModelShipping(props.shippingOption ?? props.settings.shippingOptions[0]);
    }
  }, []);

  useEffect(() => {
    props.updated(model, modelShipping);
  }, [model, modelShipping]);

  return (
    <React.Fragment>

      <div className="pb-10">
        <Row>
          <Form.Group className="">
            <Form.Label>{settings.translation?.shippingDetailsComponent?.recipientName}</Form.Label>
            <Form.Control
              name="name"
              required
              value={model.name || ""}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mt-5">
            <Form.Label>{settings.translation?.shippingDetailsComponent?.address1}</Form.Label>
            <LoadScript
              googleMapsApiKey="AIzaSyAfK7CPX7WZO8rHzM_UysYRDSy91gJ7j5o" // Replace with your Google API Key
              libraries={libraries}
            >
              <Autocomplete
                onLoad={handleLoad}
                onPlaceChanged={handlePlaceChanged}
              >
                <div className="input-group input-group-inline">
                  <Form.Control
                    required
                    name="address1"
                    value={model.address1 || ""}
                    onChange={handleChange}
                    placeholder={settings.translation?.shippingDetailsComponent?.address1Placeholder}
                  />
                  <span className="input-group-text" id="">
                    <span className="bi bi-search"></span>
                  </span>
                </div>

              </Autocomplete>
            </LoadScript>
            <span className="d-block mt-2 text-sm text-muted">{settings.translation?.shippingDetailsComponent?.streetAddress}</span>
          </Form.Group>
          <Form.Group className="mt-5">
            <Form.Label>{settings.translation?.shippingDetailsComponent?.address2}</Form.Label>
            <Form.Control
              name="address2"
              value={model.address2 || ""}
              onChange={handleChange}
            />
            <span className="d-block mt-2 text-sm text-muted">{settings.translation?.shippingDetailsComponent?.address2Help}</span>
          </Form.Group>
          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mt-5">
                <Form.Label>{settings.translation?.shippingDetailsComponent?.city}</Form.Label>
                <Form.Control
                  required
                  name="city"
                  value={model.city || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mt-5">
                <Form.Label>{settings.translation?.shippingDetailsComponent?.state}</Form.Label>
                <Form.Control
                  required
                  name="state"
                  value={model.state || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>

          </div>
          <div className="row">
            <div className="col-md-8">
              <Form.Group className="mt-5">
                <Form.Label>{settings.translation?.shippingDetailsComponent?.country}</Form.Label>
                <Form.Select
                  required
                  name="countryCode"
                  onChange={handleCountryChange}
                  value={model.countryCode}
                >
                  <option value="">{settings.translation?.shippingDetailsComponent?.countryPlaceholder}</option>
                  {countryOptions.map((country) => (
                    <option key={country.code} value={country.code}>
                      {country.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group className="mt-5">
                <Form.Label>{settings.translation?.shippingDetailsComponent?.zip}</Form.Label>
                <Form.Control
                  required
                  name="postalCode"
                  value={model.postalCode || ""}
                  onChange={handleChange}
                />
              </Form.Group>
            </div>
          </div>
        </Row>
        <div className="pt-10">
          <div className="list-group">

            {props.settings.shippingOptions?.map((option) => (
              <div key={`shipping-${option.id}`} className="list-group-item d-flex align-items-center shadow-1 border rounded mb-5">
                <div className="flex-fill">
                  <Form.Check
                    id={`default-${option.id}`}
                  >
                    <Form.Check.Input name="radioShippingOptions" type={"radio"} id={`default-${option.id}`}
                      checked={
                        modelShipping.id === option.id
                      }
                      onChange={handleShippingChange}
                      value={option.id} />
                    <Form.Check.Label><h6 className="progress-text mb-0 d-block">{option.name}</h6>
                      <span className="d-block text-sm text-muted">{option.description}</span></Form.Check.Label>
                  </Form.Check>
                </div>
                <div className="text-end">
                  <span className="h6 text-sm">{CurrencyUtil.formatCurrency(option.price ?? 0, props.settings.isoCurrencyCode)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PublicStorefrontShippingDetailsComponent;
